/**
 * Saves JWT and tenantId to browser cookies.
 * @param {string} jwt The JWT to save.
 * @param {number} tenantId tenant id
 * @param {number} expirationDays The number of days until the cookie expires.
 */

export const saveJwtToCookie = (jwt, tenantId, expirationDays = 7) => {
  const d = new Date();
  d.setTime(d.getTime() + expirationDays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();

  // Secure Flag is used since it will run on HTTPS
  document.cookie = `tenantId=${tenantId};${expires};path=/`;
  document.cookie = `auth=${jwt};${expires};path=/`;
};
